import { useLocation } from 'react-router-dom';

export function useQuery(): Record<string, string> {
  try {
    const urlSearchParams = new URLSearchParams(useLocation().search);
    return Object.fromEntries(urlSearchParams.entries());
  } catch (e) {
    return {};
  }
}
